var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.985 24.4321H4.20164C1.94906 24.4321 0.116699 22.5999 0.116699 20.3475V4.56415C0.116699 2.31157 1.94899 0.479492 4.20164 0.479492H19.985C22.2376 0.479492 24.0699 2.31179 24.0699 4.56415V20.3482C24.0696 22.6002 22.2371 24.4326 19.9848 24.4326L19.985 24.4321ZM4.20164 1.26831C2.38472 1.26831 0.906359 2.74645 0.906359 4.56302V20.3471C0.906359 22.164 2.38451 23.6418 4.20164 23.6418H19.985C21.8019 23.6418 23.2803 22.1636 23.2803 20.3471V4.56373C23.2803 2.7468 21.8021 1.26901 19.985 1.26901L4.20164 1.26874V1.26831Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6333 6.31934H12.4229V18.8552H11.6333V6.31934Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75977 12.1924H18.2956V12.982H5.75977V12.1924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.405f36434f144ec6475b6348b90abffc.svg";
export { ForwardRef as ReactComponent };